(function() {

	var blogLinks = $( '.blog-link' );

	for ( var i = 0; i < blogLinks.length; i++ ) {

		if( window.location.href.indexOf( blogLinks[ i ].getAttribute( 'href' ) ) > -1 ) {

			blogLinks[ i ].classList += ' active';

		}
	}

	var blogOptions = $( '#dropdown-blog-navigation option' );

	for ( var b = 0; b < blogOptions.length; b++ ) {

		if( window.location.href.indexOf( blogOptions[b].value ) > -1 ) {

			$( '#dropdown-blog-navigation' ).val( blogOptions[b].value );

		}
	}

	$( '#dropdown-blog-navigation' ).on( 'change', function() {

		window.location.href = $( this ).val();

	});

})();
